import { useFeedSignupPageDataQuery } from "@helloaudio/api";
import { FunctionComponent } from "react";

interface FeedDetailsProps {
  feedId: string;
}

const FeedDetails: FunctionComponent<FeedDetailsProps> = ({ feedId }) => {
  const { data } = useFeedSignupPageDataQuery(feedId);

  const imageUrl = data!.showCoverArt && data!.feedImageUrl ? data!.feedImageUrl : undefined;
  const title = data!.showTitle && data!.feedTitle ? data!.feedTitle : undefined;
  const author = data!.showAuthor && data!.feedAuthor ? data!.feedAuthor : undefined;
  const descriptionHtml =
    data!.showDescription && data!.description ? data!.description : undefined;

  const show = !!imageUrl || !!title || !!author || !!descriptionHtml;

  return show ? (
    <section className="tw-px-4 tw-my-4 md:tw-px-8 lg:tw-px-16 md:tw-my-16">
      <div className="tw-bg-white tw-p-4 md:tw-p-8 tw-flex tw-flex-col tw-gap-4 md:tw-gap-8 tw-rounded">
        {imageUrl && (
          <div className="tw-flex tw-gap-4">
            <img
              className="tw-self-center xl:tw-self-auto tw-block tw-w-24 tw-h-24 md:tw-w-32 md:tw-h-32 tw-rounded"
              src={imageUrl}
            />
            <div>
              {title && (
                <span className="tw-block tw-mb-2 tw-text-base tw-font-semibold tw-text-gray-900">
                  {title}
                </span>
              )}

              {author && (
                <span className="tw-block tw-mb-5 tw-text-sm tw-font-base tw-italic tw-text-gray-900">
                  {author}
                </span>
              )}
            </div>
          </div>
        )}

        <div>
          {descriptionHtml && (
            <p
              className="tw-m-0 tw-text-sm tw-font-medium tw-text-gray-900"
              dangerouslySetInnerHTML={{
                __html: descriptionHtml,
              }}
            />
          )}
        </div>
      </div>
    </section>
  ) : null;
};

export default FeedDetails;
